module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// JQTimer Widget

(function (fox) {

	fox.registerWidget('JQTimer', {

		configure: function (options) {
			this.registerOptions('', {
				counterWrapperId: '#counter',
				skipPreloader: true,
				dontReuseSn: true,
				initial: "00:00:30:00",
		        direction: 'down',
		        format: "99:23:59:59",
		        interval: 1000,
		        stop: "00:00:00:00",
				'handleWom.timerStopHandler': {
					widget: '@this',
					event: 'timerStop',
					callback: 'timerStopHandler'
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this._counterOptions = {};

			this
				.setOption('template', 'span' + this.getOption('counterWrapperId'))
				.prepareCounterOptions();

			this.callParent('init', arguments);
		},

		afterEmbed: function () {
			this._counter = this.initCounter();

			if (this.hook === true) {
				this.counterStop();
				this.counterReset();
			}
			
			this.callParent('afterEmbed', arguments);
		},

		initCounter: function () {
			return $(this.dom1(this.getOption('counterWrapperId')))
					.counter(this._counterOptions)
					.on('counterStop', fox.bind(function () {
						this.dispatchEvent('timerStop');
					}, this));
		},

		prepareCounterOptions: function () {
			var neededCounterOptions = ['initial', 'direction', 'format', 'interval', 'stop'];

			for (var i = neededCounterOptions.length; i--;) {
				this._counterOptions[neededCounterOptions[i]] = this.getOption(neededCounterOptions[i]);
			}
		},

		timerStopHandler: function () {
			// console.log('Timer Stop')
		},

		counterStop: function () {
			this._counter.counter('stop');

			return this;
		},

		counterStart: function (remTime) {
			var remDays, fArr;
			
			if (remTime){
				if ((remDays = remTime.split(':').shift()).length > 2) {
					fArr = this._counterOptions.format.split(':');
					fArr[0] = remDays.split('').map(function () {return 9;}).join('');

					this._counterOptions.format = fArr.join(':');
				}

				this._counterOptions.initial = remTime;
				this.embed();
			}
			else if (this._counter) {
				this._counter.counter('play');
			}

			return this;
		},

		counterReset: function () {
			this._counter.counter('reset');

			return this;
		}

	}, 'Widget');

})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/publisher/widget/jqtimer.js
// module id = 458
// module chunks = 4